import { convertToTitleCase } from "../../utils";
import { convertToSpacedLowerCase } from "../../utils/convertToSpacedLowerCase";

type GetPlaceholderMessageOptions = {
  formatAsTitleCase?: boolean;
};

function formatPlaceholder(action: string, fieldname: string, options: GetPlaceholderMessageOptions = {}) {
  const { formatAsTitleCase } = options;

  const formattedField = formatAsTitleCase ? convertToTitleCase(fieldname) : convertToSpacedLowerCase(fieldname);

  return `${action} ${formattedField}`;
}

export function getInputPlaceholderMessage(fieldname: string, options?: GetPlaceholderMessageOptions): string {
  return formatPlaceholder("Enter", fieldname, options);
}

export function getSelectPlaceholderMessage(fieldname: string, options?: GetPlaceholderMessageOptions): string {
  return formatPlaceholder("Select", fieldname, options);
}
